import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import {
  ActionItemOrderBy,
  TargetedCheckInsContext,
} from "contexts/TargetedCheckIns";
import { useContext } from "react";

export default function OrderBy() {
  const { orderBy, setOrderBy, fetchTargetedActionItems } = useContext(
    TargetedCheckInsContext,
  );
  return (
    <ToggleButtonGroup
      color="primary"
      size="small"
      exclusive
      value={orderBy || ActionItemOrderBy.priority}
      onChange={(_, newOrderBy: ActionItemOrderBy) => {
        setOrderBy(newOrderBy);
        fetchTargetedActionItems(1, newOrderBy);
      }}
      aria-label="Gallery Type"
      sx={{ mb: 0.5 }}
    >
      <ToggleButton value={ActionItemOrderBy.priority}>Priority</ToggleButton>
      <ToggleButton value={ActionItemOrderBy.created_at}>
        Created At
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
